import React, { useEffect, useRef } from "react";
import { generateExtensionLetter } from "../utilities/generateExtensionLetter";
import { FaTimes } from "react-icons/fa";
import { formatDate } from "../utilities/formatDate";
import { fetchApplications } from "../utilities/fetchAllApplications";

const ExtensionPreviewModal = ({
  isOpen,
  applicantDetails,
  onClose,
  newEndDate,
  extensionReqDate,
}) => {
  const pdfRef = useRef(null);

  useEffect(() => {
    if (applicantDetails && newEndDate && extensionReqDate) {
      const pdfUrl = generateExtensionLetter(
        applicantDetails,
        newEndDate,
        extensionReqDate
      );
      if (pdfRef.current) {
        pdfRef.current.src = pdfUrl;
      }
    }
  }, [applicantDetails, newEndDate, extensionReqDate]);

  return (
    isOpen && (
      <div className="fixed inset-0 bg-gray-500 bg-opacity-75 flex justify-center items-center z-50">
        <div className="bg-white rounded-lg p-4 w-[50vw] max-h-[90vh] overflow-y-auto shadow-lg">
          <div className="text-right">
            <button
              className="text-red-500 hover:text-red-700 font-extrabold text-xl"
              onClick={() => {
                onClose();
              }}
            >
              <FaTimes />
            </button>
          </div>
          <div className="flex">
            {/* PDF Preview on the left */}
            <iframe ref={pdfRef} className="w-[55%] h-[740px]" />

            {/* Applicant details on the right */}
            <div className="w-[46%] mt-10 ml-4">
              <h1 className="mb-3 text-xl text-green-700 text-center underline font-bold">
                Internship Extension Letter Preview
              </h1>
              <p className="font-medium">
                The Selected intern will be given an extension with the details
                below:
              </p>
              <p className="mt-6">Applicant Name: </p>
              <p className="text-lg uppercase font-semibold mb-3">
                {applicantDetails?.surname} {applicantDetails?.firstName}
              </p>
              <p className="mb-3">
                Phone Number: <strong>{applicantDetails?.phoneNumber}</strong>
              </p>
              <p className="mb-3">
                Department:{" "}
                <strong>{applicantDetails?.internshipDepartment}</strong>
              </p>
              <p className="mb-3">
                Supervisor:{" "}
                <strong>{applicantDetails?.internshipSupervisor}</strong>
              </p>
              <p className="mb-3">
                Current Internship End Date:{" "}
                <strong>
                  {formatDate(applicantDetails?.internshipEndDate)}
                </strong>
              </p>
              <p className="mb-3">
                New Internship End Date:{" "}
                <strong>{formatDate(newEndDate)}</strong>
              </p>
              <button
                className="bg-gray-600 rounded-lg mt-6  text-sm p-2 px-12 font-semibold text-white"
                onClick={onClose}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    )
  );
};

export default ExtensionPreviewModal;
